import { Injectable } from "@angular/core";
import { Schedule } from "@models/schedule.model";
import BaseService from "./base.service";

/**
 * A variant of the BaseService where the Scheduling information is stored.
 *
 * @class ScheduleService
 * @augments {BaseService<Schedule>}
 */
@Injectable({
  providedIn: "root",
})
export class ScheduleService extends BaseService<Schedule> {}
